<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    宝安中心站<br>
站点介绍<br>
宝安中心站位于宝安区新湖路与创业一路交叉路口下方，顺新湖路布置。 是一、五号线换乘站，该站为地下站，F出入口有壹方城大型购物中心。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:31	23:17	1号线	2分钟	4分40秒<br>
机场东	06:03	23:51	1号线	2分钟	4分40秒<br>
赤湾	06:12	00:01	5号线	3分钟	5分25秒<br>
黄贝岭	06:19	23:20	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:37	23:17	1号线	3分45秒	5分45秒<br>
机场东	06:09	23:49	1号线	3分45秒	5分45秒<br>
赤湾	06:12	00:01	5号线	4分钟	6分钟<br>
黄贝岭	06:26	23:20	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:37	00:17	1号线	3分45秒	5分45秒<br>
机场东	06:09	00:49	1号线	3分45秒	5分45秒<br>
赤湾	06:12	01:01	5号线	4分钟	6分钟<br>
黄贝岭	06:26	00:20	5号线	4分钟	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
新湖路北侧（东）、海旺中学<br><br>
B出入口:<br>
创业一路南侧（东）、宏发中心大厦、AEON永旺宝安中心店<br><br>
C出入口:<br>
创业一路北侧、滨海小学<br><br>
D出入口:<br>
新湖路北侧（西）、风临洲、龙光天悦龙庭、宝安中心公交站<br><br>
E出入口:<br>
新湖路南侧、中共深圳市宝安区委员会、深圳市宝安区人民政府、海滨广场<br><br>
F出入口:<br>
新湖路西侧、创业一路南侧（西）、国际西岸商务大厦、壹方城购物中心、宝安中心<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 宝安中心站②<br>
M375、M376、M377、M379、M473、西湾公园假日专线1<br><br>
D出入口:<br>
公交站名： 宝安中心站<br>
B826、M157、M350、M375、M376、M377、M470、M550、西湾公园假日专线1<br><br>
E出入口:<br>
公交站名： 宝安中心站②<br>
B826、B828、M379、M473<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


